import { useEffect, useState } from 'react';
var TECLAS_BLOQUEADAS = ['c', 'x', 's', 'p', 'a', 'u'];
var TECLAS_DEV_TOOLS = ['i', 'j', 'c'];
/**
 * Barreiras contra cópia, impressão e captura enquanto um documento protegido está aberto.
 * Só é aplicado quando `enabled` é verdadeiro, mantendo o comportamento atual dos links externos.
 */
export var useDocumentProtection = function (enabled) {
    var _a = useState(false), isHidden = _a[0], setIsHidden = _a[1];
    useEffect(function () {
        if (!enabled) {
            return undefined;
        }
        var bloquearEvento = function (event) {
            event.preventDefault();
        };
        var handleKeyDown = function (event) {
            var _a;
            var tecla = (_a = event.key) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            var comModificador = event.ctrlKey || event.metaKey;
            var ehDevTools = event.key === 'F12' || (comModificador && event.shiftKey && TECLAS_DEV_TOOLS.includes(tecla));
            var ehAtalhoBloqueado = comModificador && !event.shiftKey && TECLAS_BLOQUEADAS.includes(tecla);
            if (ehDevTools || ehAtalhoBloqueado) {
                event.preventDefault();
                event.stopPropagation();
            }
            if (event.key === 'PrintScreen') {
                setIsHidden(true);
                window.setTimeout(function () { return setIsHidden(false); }, 1500);
            }
        };
        var esconderConteudo = function () { return setIsHidden(true); };
        var exibirConteudo = function () { return setIsHidden(false); };
        var handleVisibilityChange = function () { return setIsHidden(document.visibilityState !== 'visible'); };
        document.addEventListener('contextmenu', bloquearEvento);
        document.addEventListener('selectstart', bloquearEvento);
        document.addEventListener('dragstart', bloquearEvento);
        document.addEventListener('copy', bloquearEvento);
        document.addEventListener('cut', bloquearEvento);
        document.addEventListener('keydown', handleKeyDown, true);
        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('blur', esconderConteudo);
        window.addEventListener('focus', exibirConteudo);
        window.addEventListener('beforeprint', esconderConteudo);
        window.addEventListener('afterprint', exibirConteudo);
        return function () {
            document.removeEventListener('contextmenu', bloquearEvento);
            document.removeEventListener('selectstart', bloquearEvento);
            document.removeEventListener('dragstart', bloquearEvento);
            document.removeEventListener('copy', bloquearEvento);
            document.removeEventListener('cut', bloquearEvento);
            document.removeEventListener('keydown', handleKeyDown, true);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('blur', esconderConteudo);
            window.removeEventListener('focus', exibirConteudo);
            window.removeEventListener('beforeprint', esconderConteudo);
            window.removeEventListener('afterprint', exibirConteudo);
            setIsHidden(false);
        };
    }, [enabled]);
    return { isHidden: isHidden };
};
